import React, { useContext, useEffect, useState } from 'react';
import { Route, Switch, useRouteMatch, useParams, useLocation } from 'react-router-dom';
import { getUser } from './../../api/users';

import ProfilePanel from './profile_panel/index';
import LoadingScreen from '../system/loading_screen';
import NotFoundPage from '../system/not_found_page';
import SimpleSlidingMenu from '../ui_kit/utilities/simple_sliding_menu';
import Context from '../../utils/context';
import About from './about_me_sections/about';

import styles from './index.module.css';

export default function Profile() {
  const context = useContext(Context);
  const currentUser = context.auth.getCurrentUser();
  let { id } = useParams();
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  let { path } = useRouteMatch();
  path = path.replace(`:id`, id);

  let menuItems = [
    {
      linkText: 'About me',
      idToScrollTo: 'about-me',
      href: `${path}/about-me`,
      pendoTag: 'profile page navigation - about me',
    },
  ];

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    setUser(undefined);
    getUser(
      id,
      (loadedUser) => {
        setUser(loadedUser);
        setLoading(false);
      },
      () => {
        setUser(undefined);
        setNotFound(true);
        setLoading(false);
      }
    );
  }, [id]);

  let profileIsCurrentUser = false;
  if (context.auth.isLoggedIn() && currentUser.slug === id) {
    profileIsCurrentUser = true;
  }
  if (profileIsCurrentUser) {
    menuItems.push({
      linkText: 'Activity',
      idToScrollTo: 'activity',
      href: `${path}/activity`,
      pendoTag: 'profile page navigation - activity',
    });
  }

  const location = useLocation();
  let defaultSelectedMenuItem = menuItems[0];
  menuItems.forEach((item) => {
    if (item.href === location.pathname) {
      defaultSelectedMenuItem = item;
    }
  });
  const [selectedMenuItem, setSelectedMenuItem] = useState(defaultSelectedMenuItem);

  if (loading) {
    return <LoadingScreen />;
  }

  if (notFound || !user) {
    return <NotFoundPage />;
  }

  return (
    <div className={`${styles.profile_wrapper} container-fluid`}>
      <div className={`container`}>
        <div className='row'>
          <div className='col-lg-4'>{user.current_profile && <ProfilePanel profile={user.current_profile} />}</div>
          <div className='col-lg-6'>
            <SimpleSlidingMenu menuItems={menuItems} setMarker={selectedMenuItem} setMarkerItem={setSelectedMenuItem} />
            <Switch>
              <Route path={`${path}/about-me`}>
                <About user={user} />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
}
